import { render } from "./DaiwariHistoryReference.vue?vue&type=template&id=3c79b89b&scoped=true"
import script from "./DaiwariHistoryReference.vue?vue&type=script&lang=js"
export * from "./DaiwariHistoryReference.vue?vue&type=script&lang=js"

import "./DaiwariHistoryReference.vue?vue&type=style&index=0&id=3c79b89b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c79b89b"]])

export default __exports__